import { gql } from 'graphql-request'

export default gql`
  query getRecipientData($handle: Int!) {
    applications {
      registrationUpdate {
        cardRecipient(handle: $handle) {
          name
          handleRecipient
          handleCard
          handleRegistration
          code
          type
          dependentType
          blocked
          nameMother
          cpf
          email
          address {
            zipcode
            handleResidential
            handleMail
            street
            neighborhood
            city
            state
            number
            complement
            handleState
            handleCity
            phoneDDD
            phonePrefix
            phoneNumber
            cellPhoneDDD
            cellPhonePrefix
            cellPhoneNumber
          }
        }
      }
    }
  }
`
